import { NavigateFunction } from 'react-router';

import toKebabCase from '@anwb/poncho/utilities/to-kebab-case';
import { GaFunnelInfo } from 'types/gaFunnelInfo';

import { trackEvent } from './trackEvent';

const plBasePath = '/auto/private-lease/anwb-private-lease/aanvragen';

export const basePath: string = process.env.NODE_ENV === 'development' ? '' : plBasePath;

export const STEPS = {
	CAR_CONTRACT: 'samenstelling-auto-en-contract',
	USER_INFORMATION: 'persoonlijke-gegevens',
	OVERVIEW: 'gegevens-controleren',
	THANK_YOU: 'bedankt',
};

export const STEPS_ORDER = [
	STEPS.CAR_CONTRACT,
	STEPS.USER_INFORMATION,
	STEPS.OVERVIEW,
	STEPS.THANK_YOU,
];

export const getCurrentStep = (): string => getStep(window.location.pathname);

export const getCurrentStepNumber = (): number => {
	const stepsOrder = STEPS_ORDER;
	return stepsOrder.indexOf(getCurrentStep()) + 1;
};

/**
 * Get URI / pathname for a step
 * @param {string} step
 */
export const getStepPath = (step?: string): string => `${basePath}${step ? `/${step}` : ''}`;

export const getStepPathForThankYou = (): string => {
	const urlParams: URLSearchParams = new URLSearchParams(window.location.search);
	const condition: string | null = urlParams.get('condition');

	return `${basePath}/${STEPS.THANK_YOU}${condition ? `/?condition=${condition}` : ''}`;
};

export const getStepPathWithCarParam = (step?: string): string => {
	const urlParams: URLSearchParams = new URLSearchParams(window.location.search);
	const carId: string | null = urlParams.get('carId');
	const condition: string | null = urlParams.get('condition');

	return `${basePath}${step ? `/${step}` : ''}${carId ? `/?carId=${carId}` : ''}${
		condition ? `&condition=${condition}` : ''
	}`;
};

export const getStep = (pathname: string): string => {
	const cleanPath = pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;

	return cleanPath.substring(cleanPath.lastIndexOf('/') + 1);
};

type TrackingComponent = 'progress-bar' | 'navigation-button';

export const gotoStep = (
	step: string,
	eventAction: string,
	navigate: NavigateFunction,
	gaFunnelInfo: GaFunnelInfo,
	trackingComponent?: TrackingComponent
): void => {
	if (trackingComponent === 'progress-bar') {
		trackEvent({
			event: 'user_interaction',
			type: 'form',
			component: 'form-progress',
			field: toKebabCase(eventAction),
			action: 'click',
			actionValue: '',
			...gaFunnelInfo,
		});
	} else if (trackingComponent === 'navigation-button') {
		trackEvent({
			event: 'user_interaction',
			type: 'form',
			component: 'button',
			field: '',
			action: 'click',
			actionValue: toKebabCase(eventAction),
			status: 'valid',
			...gaFunnelInfo,
		});
	}

	if (step === STEPS.THANK_YOU) {
		navigate(getStepPathForThankYou());
	} else {
		navigate(getStepPathWithCarParam(step));
	}
};
